import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { Location } from '@angular/common';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';

declare const swal: any;

@Component({
	selector: 'app-view-batch-details-applicant',
	templateUrl: './view-batch-details-applicant.component.html',
	styleUrls: ['./view-batch-details-applicant.component.css']
})
export class ViewBatchDetailsApplicantComponent implements OnInit {
	@ViewChild('startDate') startDate: ElementRef;
	batchId: any;
	batchDetails: any;
	userInfo: any;
	userPaymentDetails: any;
	batchFeeDetailsForm: FormGroup;
	modeOfPayement = [
		'Bank Challan',
		'Cash',
		'Cheque',
		'Demand Draft',
		'Debit/Credit Card',
		'NetBanking/Online'
	];
	bankNames = [
		'Allahabad Bank',
		'Andhra Bank',
		'Axis Bank',
		'Bandhan Bank',
		'Bank of Baroda',
		'Bank of India',
		'Bank of Maharashtra',
		'Canara Bank',
		'Catholic Syrian Bank',
		'Central Bank of India',
		'City Union Bank',
		'Corporation Bank',
		'DCB Bank',
		'Dena Bank',
		'Dhanlaxmi Bank',
		'Federal Bank',
		'HDFC Bank',
		'ICICI Bank',
		'IDBI Bank',
		'IDFC Bank',
		'Indian Bank',
		'Indian Overseas Bank',
		'IndusInd Bank',
		'Jammu & Kashmir Bank',
		'Karnataka Bank',
		'Karur Vysya Bank',
		'Kotak Mahindra Bank',
		'Lakshmi Vilas Bank',
		'Nainital Bank',
		'Oriental Bank of Commerce',
		'Punjab and Sind Bank',
		'Punjab National Bank',
		'RBL Bank',
		'South Indian Bank',
		'State Bank of India',
		'Syndicate Bank',
		'Tamilnad Mercantile Bank Limited',
		'UCO Bank',
		'Union Bank of India',
		'United Bank of India',
		'Vijaya Bank',
		'Yes Bank',
		'Other'
	];
	dateObject = {
		date: new Date(),
		placeholder: 'Select Date',
		format: 'dd/MM/yyyy'
	};
	constructor(
		private _batchService: BatchService,
		private _activateRoute: ActivatedRoute,
		private _formBuilder: FormBuilder,
		private scriptLoaderService: ScriptLoaderService,
		private location: Location,
		private currentUser: CurrentUserService
	) {
		_activateRoute.params.subscribe(res => {
			console.log(res);
			this.batchId = res.batchId;
		});
		this.defineForm();
		this.getCurrentUser();
	}

	defineForm() {
		this.batchFeeDetailsForm = this._formBuilder.group({
			modeOfPayment: ['', [Validators.required]],
			nameOfBank: ['', [Validators.required]],
			dateOfPayment: ['', [Validators.required]],
			refNo: [
				'',
				[Validators.required, Validators.pattern('^[A-Za-z0-9]*$')]
			],
			remarks: [''],
			amount: [
				this.batchDetails && this.batchDetails.batchFee
					? this.batchDetails.batchFee
					: null,
				[Validators.required]
			]
		});
	}
	ngOnInit() {
		this.getBatchDetails();
		this.scriptLoaderService.addScriptTagToElementDOM(
			'../../../assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		);
	}

	dateValidation() {
		if (this.startDate.nativeElement.value) {
			console.log(this.startDate.nativeElement.value);
			const checkStartDate = new Date(this.startDate.nativeElement.value.split('/').reverse().join('/')).toISOString();
			this.batchFeeDetailsForm.get('dateOfPayment').setValue(checkStartDate);
		}

	}

	getCurrentUser() {
		this.currentUser.getCurrentUser().subscribe(loggedInUser => {
			this.userInfo = loggedInUser
			console.log(this.userInfo);
		});
	}

	addPayment() {
		let isPaymentAdded = false;
		console.log(this.batchDetails);
		this.batchDetails.candidates.filter(res => {
			console.log(res);
			if (this.userInfo.userName === res.userName && res.paymentDetails) {
				console.log('enter');
				isPaymentAdded = true;
			} else {
				console.log('else');
				isPaymentAdded = false;
			}
		});
		if (isPaymentAdded === false) {
			this._batchService
				.updateApplicantPaymentDetails(
					this.batchId,
					this.batchFeeDetailsForm.value
				)
				.subscribe(res => {
					console.log(res);
					swal(
						'Payment Details added Successfully !!',
						'Payment details has been added to the ' +
						this.batchDetails.batchName,
						'success'
					);
				});
		} else {
			swal('Payment Details Already Submitted', '', 'warning');
		}
		console.log(this.batchFeeDetailsForm);
	}

	getBatchDetails() {
		this._batchService.getBatchDetails(this.batchId, 'applicant').subscribe(res => {
			this.batchDetails = res;
			this.defineForm();
			this.userPayment();
			console.log(this.batchDetails);
		});
	}

	userPayment() {
		console.log('bpaa', this.batchDetails);
		if (this.batchDetails && this.batchDetails.candidates.length > 0) {
			console.log('dfcdc', this.batchDetails);
			for (let index = 0; index < this.batchDetails.candidates.length; index++) {
				if (this.userInfo.userName === this.batchDetails.candidates[index].userName) {
					this.userPaymentDetails = this.batchDetails.candidates[index].paymentDetails;
				}
			}
		}


	}

	onDateChange(event) {
		this.dateObject.date = new Date(event);
		this.batchFeeDetailsForm
			.get('dateOfPayment')
			.setValue(this.dateObject.date);
	}

	goBack() {
		this.location.back();
	}
}
